import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DataService } from 'app/data.service';

@Component({
  selector: 'app-add-property-type',
  templateUrl: './add-property-type.component.html',
  styleUrls: ['./add-property-type.component.css']
})
export class AddPropertyTypeComponent implements OnInit {

  response:any;

  status:boolean;

  constructor(private dataService : DataService) { }

  propertyType: FormGroup = new FormGroup({
   	type: new FormControl('', [Validators.required])
  })

  ngOnInit(): void {

  }

  submitPropertyType(data:any){
  	this.dataService.addPropertyType(data)
  		.subscribe((response:any)=>{
  			this.response = response.message;
        this.status = response.status;
  		}, error => {
        
      })
  }

}
